import { EcosystemProjectDetailInfo } from '~/api/repository'
import { IMAGE } from '~/constants/image.constants'
import { EcosystemFeaturedSummaryModel } from '~/types/model/ecosystem/featured.model'
import { ProjectDetailModel } from '~/types/model/project-detail.model'

type EcosystemProjectSummaryParam = {
  projectId: string
  name: string
  categoryList: string[]
  logoUrl: string
  description?: string
  officialLink: string
}

export class EcosystemProjectSummaryModel {
  private readonly _projectId: string
  private readonly _name: string
  private readonly _description?: string
  private readonly _categoryList: string[]
  private readonly _logoUrl: string
  readonly officialLink: string

  constructor (data: EcosystemProjectSummaryParam) {
    this._projectId = data.projectId
    this._name =  data.name
    this._categoryList =  data.categoryList
    this._logoUrl =  data.logoUrl
    this._description = data.description
    this.officialLink = data.officialLink
  }

  get projectId () {
    return this._projectId
  }

  get name () {
    return this._name
  }

  get description () {
    return this._description
  }

  get categoryList () {
    return this._categoryList
  }

  get logoUrl () {
    return this._logoUrl || IMAGE.thumbnail.ecosystem
  }
}

export class EcosystemProjectDetailModel extends ProjectDetailModel {
  private readonly _relatedProjectList: Array<EcosystemProjectSummaryModel>
  private _featuredList: Array<EcosystemFeaturedSummaryModel>

  constructor (res: EcosystemProjectDetailInfo) {
    super(res)
    this._relatedProjectList = res.RLT.map((project) => new EcosystemProjectSummaryModel({
      projectId: project.ID,
      name: project.NM,
      categoryList: project.CATGLIST,
      logoUrl: project.LGURL,
      description: project.ONEDESC,
      officialLink: project.OFFLK
    }))
    this._featuredList = res.FTRD.map(featured => new EcosystemFeaturedSummaryModel(featured))
  }

  get relatedProjectList () {
    return this._relatedProjectList
  }

  get featuredList () {
    return this._featuredList
  }

  get logoUrl () {
    return this.about.logoUrl || IMAGE.thumbnail.ecosystem
  }
  
  get infoList () {
    return [
      {
        icon: 'category',
        label: 'Category',
        type: 'chip',
        contents: this.about.categoryList.map(category => {
          return {
            label: category,
            value: category
          }
        })
      },
      {
        icon: 'web',
        label: 'Website',
        type: this.about.officialLink ? 'link' : 'text',
        contents: this.about.officialLink ? [ {
          label: this.about.officialLink,
          value: this.about.officialLink
        } ] : ''
      },
      {
        icon: 'group',
        label: 'Community',
        type: 'link',
        contents: this.about.communityLink.map(community => {
          return {
            label: community.name,
            value: community.link,
          }
        })
      },
      {
        icon: 'more_horiz',
        label: 'Other',
        type: 'link',
        contents: this.about.otherLink.map(other => {
          return {
            label: other.name,
            value: other.link
          }
        })
      },
    ]
  }
}